export default {
  VIEW_ALIGNER_CHANGES: 'VIEW_ALIGNER_CHANGES',
  PAUSE_TREATMENT: 'PAUSE_TREATMENT',
  RESUME_TREATMENT: 'RESUME_TREATMENT',
  VIEW_WEAR_STATS: 'VIEW_WEAR_STATS',
  FORCE_CHANGE_ALIGNER: 'FORCE_CHANGE_ALIGNER',
  FORCE_CHANGE_ALIGNER_WARNING_MODAL: 'FORCE_CHANGE_ALIGNER_WARNING_MODAL',
  FORCE_CHANGE_ALIGNER_CONFIRM_MODAL: 'FORCE_CHANGE_ALIGNER_CONFIRM_MODAL',
  VIEW_LOGS: 'VIEW_LOGS',
  COMPLETE_TREATMENT: 'COMPLETE_TREATMENT',
  UPDATE_START_DATE: 'UPDATE_START_DATE',
  CONFIRM_RESUME: 'CONFIRM_RESUME',
  EXTEND_WEAR_DAYS: 'EXTEND_WEAR_DAYS',
  ALIGNER_CHECK_IN: 'ALIGNER_CHECK_IN',
} as const
